import * as React from "react";

const AddLeadIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={15} fill="none" {...props}>
    <path
      stroke="#3B82F6"
      d="M17.125 8.75h-.5v1.75a.125.125 0 0 1-.214.088.125.125 0 0 1-.036-.088V8.75h-1.75a.125.125 0 1 1 0-.25h1.75V6.75a.125.125 0 0 1 .25 0V8.5h1.75a.125.125 0 0 1 0 .25h-1.25ZM.779 13.544c1.11-1.32 2.485-2.252 4.005-2.75l1.018-.333-.909-.567a4.812 4.812 0 1 1 5.089 0l-.91.567 1.018.333c1.521.498 2.895 1.43 4.006 2.75a.125.125 0 1 1-.192.162c-1.663-1.98-3.962-3.081-6.467-3.081-2.505 0-4.803 1.1-6.466 3.08a.125.125 0 1 1-.192-.16Zm6.658-3.169a4.563 4.563 0 1 0-4.562-4.563v.001a4.567 4.567 0 0 0 4.562 4.562Z"
    />
  </svg>
);
export default AddLeadIcon;
